import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  getActiveSession,
  getJwtExpiredFullLoginPath,
  getJwtExpiredLightLoginPath,
  mscSet,
  RootState,
} from '@msc-b2c/shared-utils';

const JWT_EXPIRED_RETURN_KEY = 'mscJwtExpiredReturnUrl';
const JWT_EXPIRED_CODE = 'JWT_EXPIRED';

/**
 * Headless component — no UI rendered.
 * Watches the errorManagerCode Redux state and, when it transitions from
 * JWT_EXPIRED → '' (i.e. the ErrorManager modal was dismissed), saves the
 * current URL to session storage and redirects the user to the appropriate
 * login page (light or full, based on the active session's loginMode).
 */
export function JwtSessionHandler() {
  const errorManagerCode = useSelector((state: RootState) => state.errorManager.errorManagerCode);
  const prevCode = useRef('');

  useEffect(() => {
    if (prevCode.current === JWT_EXPIRED_CODE && errorManagerCode === '') {
      const { loginMode } = getActiveSession();
      mscSet('session', JWT_EXPIRED_RETURN_KEY, window.location.href, 365);
      window.location.href =
        loginMode === 'light' ? getJwtExpiredLightLoginPath() : getJwtExpiredFullLoginPath();
    }
    prevCode.current = errorManagerCode;
  }, [errorManagerCode]);

  return null;
}
